import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Column } from "devextreme-react/ui/data-grid";
import { Button, Popup, DataGrid, NumberBox, SelectBox, TextBox } from "devextreme-react";
import { nextStep, setDataSolicitudAgenda, lastStep, setWorkersUpdate, doGetWorkersData } from "../../actions";
import { openCloseToast } from "../../../../../../Global/actions";
import TextField from "../../../../../../Shared/fields/TextField";
import validaciones from "../../../../../../../helpers/validaciones";
import guid from "../../../../../../../helpers/guid"

const cancelButtonStyle = {
  paddingLeft: 30,
  paddingRight: 30,
};

const buttonStyle = {
  paddingLeft: 30,
  paddingRight: 30,
};

class IngresoTrabajadores extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      rutsTrabajadores: null,
      mostrarGrillaTrabajadores: false,
      mailIngresoTrabajador: null,
      rutIngresoTrabajador: null,
      isValidRut: null,
      ingresoTrabajador: [],
      ingresoRutTrabajador: [],
    };
  }

  componentDidUpdate = (prev) => {
    if(prev.isLoadFromInput !== this.props.isLoadFromInput && this.props.isLoadFromInput){
      let _arrayRut = [...new Set(this.state.ingresoRutTrabajador)];
      this.props.listaEmpleados.forEach((w, i) => {
        if (w.tipoDocumento === 1) {
          const isValid = validaciones.validateRut(w.rutEmpleado);
          if (w.rutEmpleado && w.rutEmpleado && w.rutEmpleado.length >= 8 && w.rutEmpleado.length <= 12 && isValid) {
            w.rutEmpleado = validaciones.formatRut(w.rutEmpleado, { showDots: true, showHyphen: true });
            _arrayRut = _arrayRut.filter((ee) => ee !== i);
          }else{
            if(w.rutEmpleado){
              _arrayRut.push(Number(i));
              _arrayRut = [...new Set(_arrayRut)];
            }else{
              _arrayRut = _arrayRut ? _arrayRut.filter(ee => ee !== i) : [];
            }
          }
        }
      })
      this.setState({ ingresoRutTrabajador: _arrayRut });
      this.props.dispatch(setDataSolicitudAgenda(this.props.dataSolicitudAgendaSel, false))
    }
  }

  handleChange = (e) => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    var arrayRut = [...this.state.ingresoRutTrabajador];
    const _split_id = e.element.id.split("_");
    const _element = _split_id[0];
    const _position = _split_id[1];
    switch (_element) {
      case "tipoDocumento": {
        _data.listaEmpleados[_position].tipoDocumento = e.value;
        if(e.value === 1 ){
          let tempRut = _data.listaEmpleados[_position].rutEmpleado
          if (tempRut && tempRut.length >= 8 && tempRut.length <= 12) {
            tempRut = validaciones.formatRut(tempRut, { showDots: true, showHyphen: true });
          }
          const isValid = validaciones.validateRut(tempRut);
          if (!isValid) {
            //const arrayRut = this.state.ingresoRutTrabajador;
            arrayRut.push(Number(_position));
            arrayRut = [...new Set(arrayRut)];
            this.setState({
              ingresoRutTrabajador: arrayRut,
            });
          } else {
            arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
            this.setState({ ingresoRutTrabajador: arrayRut });
          }
          _data.listaEmpleados[_position].rutEmpleado = tempRut;
        }else{
          arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
          this.setState({ ingresoRutTrabajador: arrayRut });
          _data.listaEmpleados[_position].rutEmpleado = validaciones.cleanRut(_data.listaEmpleados[_position].rutEmpleado);
        }
        break;
      }
      case "rutEmpleado": {
        if (_data.listaEmpleados[_position].tipoDocumento === 1) {
          const isValid = validaciones.validateRut(e.value);
          if (e.value && e.value.length >= 8 && e.value.length <= 12 && isValid) {
            e.value = validaciones.formatRut(e.value, { showDots: true, showHyphen: true });
            arrayRut = arrayRut.filter((ee) => ee.toString() !== _position);
            this.setState({ ingresoRutTrabajador: arrayRut });
          }else{
            if(e.value){
              arrayRut.push(Number(_position));
              arrayRut = [...new Set(arrayRut)];
              this.setState({
                ingresoRutTrabajador: arrayRut,
              });
            }else{
              this.setState({
                ingresoRutTrabajador: arrayRut ? arrayRut.filter(ee => ee !== Number(_position)) : [],
              });
            }

          }
        }

        _data.listaEmpleados[_position].rutEmpleado = e.value;
        break;
      }
      case "nombreEmpleado": {
        _data.listaEmpleados[_position].nombreEmpleado = e.value;
        break;
      }
      case "celularEmpleado": {
        _data.listaEmpleados[_position].celularEmpleado = e.value;
        break;
      }
      case "emailEmpleado": {
        const isValid = validaciones.validarEmail(e.value);
        if(isValid){
          const arrayMail = this.state.ingresoTrabajador.filter((ee) => ee !== Number(_position));
          this.setState({ ingresoTrabajador: arrayMail });
        }else{
          if(e.value){
            var arrayMail = this.state.ingresoTrabajador;
            arrayMail.push(Number(_position));
            arrayMail = [... new Set(arrayMail)]
            this.setState({
              ingresoTrabajador: arrayMail,
            });
          }else{
            this.setState({
              ingresoTrabajador: arrayMail ? arrayMail.filter(ee => ee !== Number(_position)) : [],
            });
          }
        }
        _data.listaEmpleados[_position].emailEmpleado = e.value;
        break;
      }
      case "rutTrabajadores": {
        const ruts = e.event.target.value;
        if (ruts) {
          const rutsClean = ruts.replace(/,/g, " ");
          const rutsCommas = rutsClean.split(" ");
          const rutsOnly = rutsCommas.filter((x) => x !== "");
          this.setState({ rutsTrabajadores: rutsOnly.join(", ") });
        }

        break;
      }
      default:
    }

    if (!this.props.isWorkersUpdate) this.props.dispatch(setWorkersUpdate(true));
    this.props.onSave();
    this.props.dispatch(setDataSolicitudAgenda(_data));
  }

  handleCargarTrabajadores = (e) => {
    let listaRuts = this.state.rutsTrabajadores
    if (listaRuts) {
      let rutsTrabajadores = listaRuts.split(",").map((e) => e.trim());
      this.props.dispatch(doGetWorkersData(rutsTrabajadores, this.props.dataSolicitudAgendaSel));
      this.setState({
        mostrarGrillaTrabajadores: true,
        rutsTrabajadores: null,
      });

    }
  }

  handleSave = () => {
    this.props.dispatch(nextStep());
  }

  openModalPendientes = () => {
    this.setState({ openModalPendientes: true });
  }

  handleCerrarPendientes = () => {
    this.setState({ openModalPendientes: false });
  }

  handleNextStep = (params) => {
    const _listEmploye = this.props.dataSolicitudAgendaSel.listaEmpleados;

    const tiempoSinNombre = this.props.tiempoSinNombre;

    const isDuplicated = validaciones.checkDuplicatedDocumentNumber(_listEmploye);

    if (isDuplicated) {
      this.props.dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "No puede ingresar un número de documento duplicado.",
        typeStyle: "error",
        displayTime: 5000,
      }));
      return;
    }

    var emailCheck = _listEmploye.map(function(x) {
      if(x.emailEmpleado){
        return validaciones.validarEmail(x.emailEmpleado);
      }else{
        return true
      }
    });

    var isValid = emailCheck.find(e => e === false);

    if (isValid === false) {
      this.props.dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "No puede ingresar un correo electrónico inválido.",
        typeStyle: "error",
        displayTime: 5000,
      }));
      return;
    }


    const _checkTrabajadoresSinNombre = _listEmploye.find((e) => e.rutEmpleado ? e.rutEmpleado.trim() === "" || (e.nombreEmpleado === "" || e.nombreEmpleado === null) : {});
    if (_listEmploye.length === 0) {
      this.props.dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Debe ingresar al menos 1 trabajador, o un espacio \"SIN NOMBRE\".",
        typeStyle: "error",
        displayTime: 5000,
      }));
    } else if (_checkTrabajadoresSinNombre) {
      if(tiempoSinNombre && (tiempoSinNombre && parseInt(tiempoSinNombre.Value) > 0)){
        this.setState({ openModal: true });
      }else{
        this.props.dispatch(nextStep());
      }
    } else {
      this.props.dispatch(nextStep());
    }
  }

  handleCompletar = (data) => {
    this.props.dispatch(nextStep());
  }

  renderSolicitudExamen = (form) => (
    <div className="col-12" style={{ justifyContent: "center", height: "100%" }}>
      <DataGrid
        dataSource={this.props.pendingComplaints[0].validaciones.siniestro}
        showBorders={false}
        showColumnLines={false}
        showRowLines
        height={250}
        className="simpleHeader"
        noDataText="Sin denuncias pendientes"
        hoverStateEnabled={false}
        activeStateEnabled={false}
        focusStateEnabled={false}
        rowAlternationEnabled
      >
        <Column
          dataField="TipoSiniestro"
          cellRender={(props) => <div style={{ fontWeight: "bold", color: "#004A52" }}>{props.data.tipoSiniestro.descripcionSiniestro}</div>}
        />
        <Column dataField="fechaSiniestro" dataType="date" caption="Fecha del siniestro" format="dd-MM-yyyy" />
        <Column dataField="idSiniestro" caption="ID siniestro" />
        <Column
          cellRender={(props) => (
            <Button
              className="custom-button"
              text="Completar"
              onClick={() => this.handleCompletar(props.data)}
            />
          )}
        />
      </DataGrid>
      <div style={{ textAlign: "center", marginTop: 20 }} >
        <Button
          text="Cerrar"
          type="normal"
          className="custom-ouline-button"
          onClick={this.handleCerrarPendientes}
          style={{ ...cancelButtonStyle, marginRight: 15 }}
        />
        <Button
          text="Continuar nueva denuncia"
          type="success"
          style={{ ...buttonStyle }}
          disabled={this.props.disableContinueNewComplaint}
          onClick={() => {
            this.handleCerrarPendientes();
            this.handleSave();
          }}
        />
      </div>
    </div>
  )

  incrementarTrabajadores = () => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const newList = [..._data.listaEmpleados];
    newList.push({
      idEmpleado: null,
      nombreEmpleado: "",
      rutEmpleado: "",
      celularEmpleado: null,
      emailEmpleado: "",
      tipoDocumento: 1,
    });
    _data.listaEmpleados = newList;
    if (!this.props.isWorkersUpdate) this.props.dispatch(setWorkersUpdate(true));
    this.props.dispatch(setDataSolicitudAgenda(_data));
  }

  reducirTrabajadores = () => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const newList = [..._data.listaEmpleados];
    newList.pop();
    _data.listaEmpleados = newList;
    if (!this.props.isWorkersUpdate) this.props.dispatch(setWorkersUpdate(true));
    this.props.dispatch(setDataSolicitudAgenda(_data));
  }

  removeTrabajador = (e, i, d) => {

    const _data = { ...this.props.dataSolicitudAgendaSel };
    _data.listaEmpleados = _data.listaEmpleados.filter((v, ii) => ii !== i);
    this.props.dispatch(setDataSolicitudAgenda(_data, true));
  }

  renderBoxTrabajadores = () => {
    const _data = { ...this.props.dataSolicitudAgendaSel };
    const ingresoTrabajador = this.state.ingresoTrabajador;
    const ingresoRutTrabajador = this.state.ingresoRutTrabajador;
    const card = (e,i) => {
      const rutValid = (e.rutEmpleado && ingresoRutTrabajador.find((element) => element === i) !== undefined) ? false : true
      const emailValid = e.emailEmpleado && ingresoTrabajador.find((element) => element === i) !== undefined ? false : true
      return (<div className="boxTrabajador" key={`e_${i}`}>
        <div className="row grid-table">
          <div className="grid-table-index">
            {i + 1}.
          </div>
          <div >
            <SelectBox
              id={`tipoDocumento_${i}`}
              value={e.tipoDocumento ? e.tipoDocumento : 1}
              dataSource={this.props.tipoDocumentos}
              onValueChanged={this.handleChange}
              displayExpr="Tipo"
              valueExpr="Id"
              searchEnabled
              style={{ height: 38 }}
            />
          </div>
          <div>
            <TextField
            //focusStateEnabled={false}
              hoverStateEnabled={false}
              //className={rutValid ? "valido" : "dx-invalid"}
              id={`rutEmpleado_${i}_${e.rutEmpleado}`}
              key={guid.new()}
              maxLength={50}
              onChange={this.handleChange}
              valueChangeEvent='focusout'
              //value={e.rutEmpleado + (e.rutEmpleado && !rutValid ? "-malo" : "")}
              value={e.rutEmpleado}
              isValid={rutValid}
              validationError={{ message: "RUT Inválido" }}
            />
          </div>
          <div>
            <TextField
              id={`nombreEmpleado_${i}`}
              onChange={this.handleChange}
              maxLength={100}
              onKeyUp={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^a-zA-Z ]+/, "");
              }}
              onKeyDown={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^a-zA-Z ]+/, "");
              }}
              value={e.nombreEmpleado}
              skipValidation
            />
          </div>
          <div>
            <TextField
              onChange={this.handleChange}
              id={`celularEmpleado_${i}`}
              value={e.celularEmpleado}
              maxLength={9}
              onKeyUp={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^0-9]+/, "");
              }}
              onKeyDown={(e) => {
                e.event.target.value = e.event.target.value.replace(/[^0-9]+/, "");
              }}
              skipValidation
            />
          </div>
          <div>
            <TextField
              id={`emailEmpleado_${i}`}
              key={guid.new()}
              maxLength={60}
              onChange={this.handleChange}
              value={e.emailEmpleado}
              skipValidation
              isValid={emailValid}
              validationError={{ message: "Email Inválido" }}
            />
          </div>
          <div>
            <div className="close-button">
              <Button
                icon="close"
                stylingMode="text"
                height={22}
                width={22}
                onClick={(event) => this.removeTrabajador(event, i, e)}
                useSubmitBehavior={false}
              />
            </div>
          </div>
        </div>
      </div>)};
    let _aux = this.props.listaEmpleados.map(card)
    return _aux;
  }
  handleBack = () => {
    this.props.dispatch(lastStep());
  }

  handleCerrarModal = () => {
    this.props.dispatch(nextStep());
  }

  render() {
    const { rutsTrabajadores } = this.state;
    return (

      <div className="col-12 ingresoTrabajadores" style={{ maxWidth: 880 }}>
        <Popup
          showCloseButton={false}
          visible={this.state.openModal}
          dragEnabled={false}
          maxHeight="200px"
          onHiding={this.handleCerrarModal}
          maxWidth="600px"
          showTitle={false}
          className="modalTrabajadoresSinNombre"
          contentRender={() => (<div>
            <div className="col-12" style={{ justifyContent: "center" }}>
              <div style={{ width: "100%", textAlign: "center" }}>
                Tienes agendamientos
                <strong> SIN NOMBRE </strong>
                recuerda que si no envías la información de estos trabajadores como máximo
                <strong> {this.props.tiempoSinNombre && this.props.tiempoSinNombre.Value} horas antes de la atención</strong>,
                 estos cupos serán liberados en sistema.
              </div>
            </div>

            <div>
              <Button
                type="success"
                className="next-button"
                text="Aceptar"
                onClick={this.handleCerrarModal}
              />
            </div>
          </div>)}
        />
        <div className="col-12">
          <h4 className="ingresotrabajadores-subtitle">¿Cuántos trabajadores vas a agregar?</h4>
        </div>

        <div className="col-12">
          <div className="dx-field">
            <div className="dx-field-label">Cantidad de trabajadores</div>
            <div className="dx-field-value contador">
              <Button
                className="more"
                onClick={this.reducirTrabajadores}
              >
              -
              </Button>
              <NumberBox
                min={0}
                showSpinButtons={false}
                readOnly
                value={this.props.listaEmpleados.length}
              />
              <Button
                className="less"
                onClick={this.incrementarTrabajadores}
              >
              +
              </Button>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="row zero" style={{ display: "flex", alignItems: "flex-end" }}>
            <div className="col-9 zero">
              <TextBox
                id="rutTrabajadores_"
                maxLength={100}
                label="Rut de trabajadores"
                onChange={this.handleChange}
                placeholder="Ingresa el rut de los trabajadores separados por una coma o espacio"
                value={rutsTrabajadores}
              />
            </div>
            <div className="col-3 zero" style={{ marginTop: 33 }}>
              <Button
                text="Cargar"
                type="success"
                className="newSolicitud-next-button"
                style={{ float: "right", width: 155 }}
                onClick={this.handleCargarTrabajadores}
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <p className="p-message-trabajadores">Los cupos a los que no ingreses la información del documento y nombre del trabajador, quedarán guardados como <strong>SIN NOMBRE.</strong> </p>
        </div>
        <div className="col-12 zero listaTabajadores">
          <div className="row zero headers-grid-table-new-sol">
            <div></div>
            <div>
              Tipo documento
            </div>
            <div>
              N° Documento
            </div>
            <div>
              Nombre
            </div>
            <div>
              Celular
            </div>
            <div>
              Email
            </div>
            <div>
            </div>
          </div>
          <div id="content_table_workers">
            {this.renderBoxTrabajadores()}
          </div>
        </div>
        <div className="col-12 buttons-next-prev">
          <div className="row">
            <div className="col-6">
              <Button text="Volver" className="back-button" onClick={this.handleBack} />
            </div>
            <div className="col-6">
              <Button
                text="Siguiente"
                type="success"
                className="next-button"
                onClick={this.handleNextStep}
                disabled={this.state.ingresoRutTrabajador.length || this.state.ingresoTrabajador.length || this.props.listaEmpleados.length === 0 ? true : false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.solicitudesAgendaSel.jsonData,
  companyId: state.global.companyId,
  pendingComplaints: state.solicitudesAgendaSel.pendingComplaints,
  disableContinueNewComplaint: state.solicitudesAgendaSel.disableContinueNewComplaint,
  listaEmpleados: state.solicitudesAgendaSel.dataSolicitudAgendaSel.listaEmpleados,
  formatoListaEmpleados: state.solicitudesAgendaSel.formatoListaEmpleados,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  isWorkersUpdate: state.solicitudesAgendaSel.isWorkersUpdate,
  tiempoSinNombre: state.solicitudesAgendaSel.tiempoSinNombre,
  tipoDocumentos: state.solicitudesAgendaSel.tipoDocumentos,
  isLoadFromInput: state.solicitudesAgendaSel.isLoadFromInput
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(IngresoTrabajadores);
